import {
  useNavigateLegacy as useNavigate,
  useLocationLegacy as useLocation,
} from '@leagueplatform/routing';
import { useAuth } from '@leagueplatform/auth-utils';
import { FullPageLoadingSpinner } from 'components/loaders/full-page-loading-spinner.component';
import { useUserEligibility } from 'hooks/use-user-eligibility.hook';
import { FullPageError } from 'components/error/full-page-error.component';
import { ErrorTypes } from 'hooks/use-error-message.hook';
import { useIntl } from '@leagueplatform/locales';
import { usePaymentLinkVisibility } from 'hooks/use-payment-link-visibility.hook';

export const AuthSessionContainer = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, error: authError } = useAuth();
  const {
    eligible,
    loading,
    error: eligibilityError,
  } = useUserEligibility(isAuthenticated);
  const { isAuthorized } = usePaymentLinkVisibility();
  console.log(authError, isAuthenticated, 'my bou');

  // Check authentication first
  if (isAuthenticated === undefined) {
    return <FullPageLoadingSpinner />;
  }

  // Handle authentication errors or not authenticated state
  if (authError || !isAuthenticated) {
    navigate(
      { pathname: '/' },
      {
        state: {
          redirectPath: location.pathname,
        },
      },
    );
    return null;
  }

  // Then check other loading states
  if (loading || eligibilityError === null || eligible === null) {
    return <FullPageLoadingSpinner />;
  }

  // Handle eligibility errors or ineligibility
  if (eligibilityError || !eligible) {
    return (
      <FullPageError
        errorType={ErrorTypes.NOT_ELIGIBLE}
        customMessage={formatMessage({ id: 'STR_ELIGIBILTY_ERROR' })}
      />
    );
  }

  if (!isAuthorized(location.pathname)) {
    return (
      <FullPageError
        errorType={ErrorTypes.API_ERROR}
        customMessage={formatMessage({ id: 'STR_UNAUTHORIZED_MESSAGE' })}
      />
    );
  }

  return children;
};
